import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSliders } from '@fortawesome/free-solid-svg-icons';
import { RadioGroup } from '@progress/kendo-react-inputs';
import type { FieldTypeDefinition, FieldRendererProps } from '../registry';
import { OptionsEditor } from '../shared/OptionsEditor';

function answerForOption(opt: { value: string; weight?: number }): string | number {
  return typeof opt.weight === 'number' ? opt.weight : opt.value;
}

function LikertScaleRenderer({ field, value, onChange, readOnly }: FieldRendererProps) {
  const options = field.options ?? [];
  const data = options.map((o) => ({ label: o.label, value: answerForOption(o) }));
  const radioValue = typeof value === 'string' || typeof value === 'number' ? value : null;
  return (
    <RadioGroup
      data={data}
      value={radioValue}
      onChange={(e) => onChange(e.value ?? null)}
      disabled={readOnly}
      layout="horizontal"
    />
  );
}

export const definition: FieldTypeDefinition = {
  key: 'SCALE',
  label: 'Likert Scale',
  category: 'choice',
  icon: <FontAwesomeIcon icon={faSliders} fixedWidth />,
  defaultProps: {
    label: 'New scale item',
    isRequired: false,
    options: [
      { id: 'o1', value: '0', label: 'Not at all', order: 0, weight: 0 },
      { id: 'o2', value: '1', label: 'Several days', order: 1, weight: 1 },
      { id: 'o3', value: '2', label: 'More than half the days', order: 2, weight: 2 },
      { id: 'o4', value: '3', label: 'Nearly every day', order: 3, weight: 3 },
    ],
  },
  Renderer: LikertScaleRenderer,
  PropertyEditor: OptionsEditor,
};
